const wordCount = (str) => {
    const matches = str.match(/(\w+)/g);
    return matches ? matches.length : 0;
}

export {wordCount}